import { getHandleNearImagePoint, getProximityThreshold, getToolState } from 'app/CornerstoneTools';
import { Point, InteractionType } from '../types';
import { IBaseAnnotationTool } from 'cornerstone-tools';

/**
 * Filters an array of tools, returning only tools with moveable handles at the
 * mouse location.
 */
export default function getToolsWithMoveableHandles(
  element: HTMLElement,
  tools: IBaseAnnotationTool[],
  coords: Point,
  interactionType: InteractionType = 'mouse'
): IBaseAnnotationTool[] {
  return tools.filter((tool) => {
    const distanceThreshold = getProximityThreshold(interactionType, tool.name);
    const toolState = getToolState(element, tool.name);

    for (let i = 0; i < toolState.data.length; i++) {
      if (
        getHandleNearImagePoint(element, toolState.data[i].handles, coords, distanceThreshold) !==
        undefined
      ) {
        return true;
      }
    }

    return false;
  });
}
